import axios from "axios";

export default {
	getMessage(messageID) {
		return axios.get(`/v3/message/${messageID}`);
	},

	getResponseMessages(responseID) {
		return axios.get(`/v3/response/${responseID}/messages`);
	},

	viewMessage(messageID) {
		return axios.post(`/v3/message/${messageID}/view`);
	},

	getUnreadMessages(noTimeout) {
		let config = {};
		if (noTimeout) {
			config.headers = { "X-No-Timeout": true };
		}
		return axios.get(`/v3/messages/unread`, config);
	},

	getWorkTableMessageCounts(asmtID, classID) {
		return axios.get(`/v3/class/${classID}/assessment/${asmtID}/messages`);
	},

	viewResponseMessages(responseID) {
		return axios.post(`/v3/response/${responseID}/messages/view`);
	},

	addMessage(responseID, message) {
		return axios.post(`/v3/response/${responseID}/message`, message);
	},

	saveMessage(message) {
		return axios.post("/v3/message", message);
	}
};



// WEBPACK FOOTER //
// ./src/services/MessageService.js